import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'lodash-es';
import { FilterBase } from '@nimbus-library/features/shared/components/nimbus-grid-filter/nimbus-filter-base';
import { FilterText } from '@nimbus-library/features/shared/components/nimbus-grid-filter/domain/filter-text.model';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { NimbusFilterTextInputComponent } from '@nimbus-library/features/shared/components/nimbus-grid-filter/nimbus-filter-text-input/nimbus-filter-text-input.component';

@Component({
  standalone: false,
  selector: 'nimbus-filter-text',
  templateUrl: './nimbus-filter-text.component.html',
  styleUrls: ['./nimbus-filter-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NimbusFilterTextComponent extends FilterBase<string[], FilterText> {
  @ViewChild('textInput')
  public textInput: NimbusFilterTextInputComponent;

  protected valuesEmpty: string[][] = [[], ['']];

  public constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly translateService: TranslateService,
  ) {
    super();
  }

  public onDetach(): void {
    this.setFilterValue([this.textInput.searchControl.value]);
  }

  public onValueChanged(): void {
    this.isOpen$.next(false);
  }

  protected getSummary(): string {
    const filterValue = first(this.filterValue || []);
    if (!filterValue?.length) {
      return this.translateService.instant(TranslationKeys.FilterAll);
    }

    return filterValue;
  }

  protected onFilterValueChanged(): void {}

  private setFilterValue(filterValue: string[]): void {
    this.filterValue = filterValue;
    this.filterValueChanged.emit(this.filterValue);
    this.summary = this.getSummary();
    this.changeDetectorRef.detectChanges();
  }
}
